module.exports = __webpack_public_path__ + "static/media/ic-pickup-spot.0cc23f8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-pickup-spot.svg
// module id = 654
// module chunks = 14